import { array, arrayOf, number, object } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { useUserData } from "Flocknote/apiHooks";

import { useOpenSacramentModal } from "./useOpenSacramentModal";

export default function SacramentSelectResult({
  selection,
  options,
  entityID,
  extendedFieldData,
}) {
  const [{ canEditSacraments }] = useUserData();

  const { openSacramentModal } = useOpenSacramentModal({
    targetUserID: entityID,
    defaultFieldTypeInstanceMapping:
      extendedFieldData?.defaultFieldTypeInstanceMapping,
    networkFieldID: extendedFieldData?.parentNetworkFieldID,
  });

  const handleClick = () => {
    if (!canEditSacraments) return;
    openSacramentModal();
  };

  const content = options.find((option) => option.id === selection[0])?.value;

  return (
    <Wrapper
      onClick={handleClick}
      $canEditSacraments={canEditSacraments}
      role="button"
    >
      {content}
    </Wrapper>
  );
}

SacramentSelectResult.propTypes = {
  selection: arrayOf(number),
  options: array,
  entityID: number,
  extendedFieldData: object,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  height: 16px;
  font-weight: 400;
  color: #384a5d;
  cursor: ${(p) => (p.$canEditSacraments ? "pointer" : "default")};
  padding: 6px 5px 5px;
`;
